module.exports = __webpack_public_path__ + "static/media/mit_csail_logo.09294dbd.png";